export const EXTERNAL_NETWORK_PATH_NAME = 'external-networks';

export const EGRESS_STRATEGY_VALUES = [
  'DIRECT',
  'CONNECTOR',
  'ROTATING_PROXY',
] as const;

export type EgressStrategy = (typeof EGRESS_STRATEGY_VALUES)[number];

export const DEFAULT_EGRESS_STRATEGY: EgressStrategy = 'DIRECT';
